export const CrudlStatus = {
  CREATE: { display: "create", value: "CREATE" },
  UPDATE: { display: "update", value: "UPDATE" },
  DELETE: { display: "delete", value: "DELETE" },
  LIST: { display: "retrieved", value: "LIST" },
  VIEW: { display: "view", value: "VIEW" }
};
export const ViewState = {
  CARD: "CARD",
  TABLE: "TABLE",
  OVERLAY: "OVERLAY",
  NONE: "NONE"
};

export const ValidateState = {
  DELETE: "DELETE",
  CONFIRM: "CONFIRM",
  NONE: "NONE"
};

export const LogLevel = {
  STANDARD: "standard",
  ERROR: "error",
  SEVERE: "severe",
  WARNING: "warning"
};

export const ToggleState = {
  ON: "ON",
  OFF: "OFF"
};

export const PageState = {
  IDLE: "IDLE",
  LOADING: "LOADING",
  ERROR: "ERROR"
};

//General
export const typeOptions = [
  { label: "Repair", value: "Repair" },
  { label: "Resale", value: "Resale" }
];

//Employees
export const roleTypeOptions = [
  { label: "Admin", value: 10 },
  { label: "Employee", value: 20 }
];

//Goods
export const goodsStatusOptions = [
  { label: "Expected", value: "EXPECTED" },
  { label: "Received", value: "RECEIVED" },
  { label: "Updated on Xero", value: "UPDATED_ON_XERO" }
];

export const goodsCollectedByOptions = [
  { label: "Collected by Capcon", value: "COLLECTED_BY_CAPCON" },
  {
    label: "Collected by Capcon Courier",
    value: "COLLECTED_BY_CAPCON_COURIER"
  },
  { label: "Delivered by Client", value: "DELIVERED_BY_CLIENT" },
  {
    label: "Delivered by Client Courier",
    value: "DELIVERED_BY_CLIENT_COURIER"
  }
];

//Dispatches
export const dispatchStatusOptions = [
  { label: "Not Started", value: "NOT_STARTED" },
  { label: "Being Picked", value: "BEING_PICKED" },
  { label: "Ready for Dispatch", value: "READY_FOR_DISPATCH" },
  { label: "Completed", value: "COMPLETED" }
];

export const dispatchesCollectedByOptions = [
  { label: "Delivery by Capcon", value: "DELIVERY_BY_CAPCON" },
  {
    label: "Delivery by Capcon Courier",
    value: "DELIVERY_BY_CAPCON_COURIER"
  },
  { label: "Collection by Client", value: "COLLECTION_BY_CLIENT" },
  {
    label: "Collection by Client Courier",
    value: "COLLECTION_BY_CLIENT_COURIER"
  }
];



// WEBPACK FOOTER //
// ./src/common/config/AppConstants.js